import { useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import type { FormData, AvailableProvider } from "../../types";
import { DEFAULT_FORM_VALUES } from "../constants";

export function useFormSetup() {
  const [mcc, setMcc] = useState<number | undefined>(undefined);
  const [selectedProvider, setSelectedProvider] =
    useState<AvailableProvider | null>(null);

  const formStateRef = useRef({
    lastExistingProviderId: null as string | null,
    isInitializing: false,
    previousSelectedProviderId: null as string | null,
    hasAddModeInitialized: false,
  });

  const {
    register,
    watch,
    setValue,
    control,
    handleSubmit,
    formState: { errors: formErrors },
    reset,
    trigger,
    getValues,
    clearErrors,
  } = useForm<FormData>({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    criteriaMode: "all",
    defaultValues: DEFAULT_FORM_VALUES,
  });

  return useMemo(
    () => ({
      register,
      watch,
      setValue,
      control,
      handleSubmit,
      formErrors,
      reset,
      trigger,
      getValues,
      clearErrors,
      mcc,
      setMcc,
      selectedProvider,
      setSelectedProvider,
      formStateRef,
    }),
    [
      register,
      watch,
      setValue,
      control,
      handleSubmit,
      formErrors,
      reset,
      trigger,
      getValues,
      clearErrors,
      mcc,
      selectedProvider,
    ],
  );
}
